import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { VersionDialog } from '../views/components/dialogs';
import { AwareHttpService } from '@appbolaget/aware-http';
import { Version } from '@appbolaget/aware-model';
import { AwareAuthService } from '@appbolaget/aware-auth';

@Injectable()
export class VersionService {
    updateTypesThatRequireRefresh: string[] = ['major', 'minor', 'patch'];
    updateTypesThatRequireSignout: string[] = ['major', 'minor'];
    version: Version;

    VERSION_DIALOG_OPENED: boolean;

    private _interval: any;

    private awareAuth = inject(AwareAuthService);
    constructor(
        public api: AwareHttpService,
        public storage: LocalStorageService,
        public dialogService: MatDialog,
    ) {}

    init() {
        let version = this.storage.retrieve('version');

        if (!version) {
            version = { version: '1.0.1' };

            this.storage.store('version', version);
        }

        this.version = new Version(version);

        this.checkVersion(true);

        if (this._interval) {
            clearInterval(this._interval);
        }

        this._interval = setInterval(() => {
            this.checkVersion();
        }, 45000);
    }

    checkVersion(firstCheck: boolean = false) {
        this.api
            .show('versions', 'skills')
            .with('meta')
            .execute()
            .subscribe((result) => {
                let version = new Version(result['data']);

                if (firstCheck) {
                    this.setVersion(version);
                } else {
                    if (version.commit !== this.version.commit) {
                        let updateType = this._getUpdateType(version);

                        if (this.updateTypesThatRequireRefresh.includes(updateType)) {
                            if (!this.VERSION_DIALOG_OPENED) {
                                this._displayVersionDialog(version, updateType);
                            }
                        }
                    }
                }
            });
    }

    setVersion(version: Version) {
        this.version = version;

        this.storage.store('version', version);
    }

    private _displayVersionDialog(version: Version, updateType: string) {
        this.VERSION_DIALOG_OPENED = true;

        let dialog = this.dialogService.open(VersionDialog, {
            disableClose: true,
            data: {
                version,
                updateType,
            },
        });

        dialog.afterClosed().subscribe((update) => {
            if (update) {
                this.setVersion(version);

                if (this.updateTypesThatRequireSignout.includes(updateType)) {
                    this.awareAuth.logout();
                }

                window.location.reload();
            }
        });
    }

    private _getUpdateType(version: Version) {
        let newSemantic = version.version.split('.');
        let prevSemantic = this.version.version.split('.');

        if (parseInt(newSemantic[0], 10) > parseInt(prevSemantic[0])) {
            return 'major';
        }

        if (parseInt(newSemantic[1], 10) > parseInt(prevSemantic[1])) {
            return 'minor';
        }

        if (parseInt(newSemantic[2], 10) > parseInt(prevSemantic[2])) {
            return 'patch';
        }

        return 'same';
    }
}
